import { render, staticRenderFns } from "./BoardUser.vue?vue&type=template&id=248d5f61&scoped=true&"
import script from "./BoardUser.vue?vue&type=script&lang=js&"
export * from "./BoardUser.vue?vue&type=script&lang=js&"
import style0 from "./BoardUser.vue?vue&type=style&index=0&id=248d5f61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d5f61",
  null
  
)

export default component.exports